<template>
  <div>
    <el-dialog
      title="发送邮件"
      center
      width="700px"
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="form" :model="form" label-width="160px" size="mini">
        <el-form-item label="模板名称：">
          <label>{{ this.value.mailTemplate.name }}</label>
        </el-form-item>
        <el-form-item label="所有分区：">
          <el-switch
            v-model="form.isToAllZones"
            @change="onIsToAllZonesSwitchChange"
            active-color="#13ce66"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="自选分区：" v-show="!form.isToAllZones">
          <zone-selector
            placeholder="请选择（可多选）"
            multiple
            @change="onZoneSelectorChange"
            ref="zoneSelector"
          >
          </zone-selector>
        </el-form-item>
        <el-form-item label="按玩家ID还是按渠道：">
          <el-radio-group
            v-model="form.isSendByPlayerIds"
            @change="onIsSendByPlayerIdsRadioGroupChange"
          >
            <el-radio :label="true">按玩家ID</el-radio>
            <el-radio :label="false">按渠道</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="!form.isSendByPlayerIds">
          <el-form-item label="所有渠道：">
            <el-switch
              v-model="form.isToAllChannels"
              @change="onIsToAllChannelsSwitchChange"
              active-color="#13ce66"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="自选渠道：" v-show="!form.isToAllChannels">
            <channel-selector
              placeholder="请选择（可多选）"
              multiple
              @change="onChannelSelectorChange"
              ref="channelSelector"
            >
            </channel-selector>
          </el-form-item>
        </div>
        <el-form-item label="玩家ID集合：" v-show="form.isSendByPlayerIds">
          <el-input
            type="textarea"
            rows="10"
            v-model="form.playerIds"
            placeholder="可放多个ID，每行放1个"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件：">
          <mail-attachment
            v-for="item of form.attachments"
            :key="item.seq"
            :availableAttachments="availableAttachments"
            v-model="item.data"
            @remove="removeAttachment(item.seq)"
          ></mail-attachment>
          <el-button @click="addNewAttachment()" class="el-icon-plus"
            >添加</el-button
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" icon="el-icon-s-promotion" @click="submit()"
          >发送</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";

import ZoneSelector from "@/components/ZoneSelector";
import ChannelSelector from "@/components/ChannelSelector";
import MailAttachment from "./MailAttachment.vue";

export default {
  data() {
    return {
      visible: true,
      form: {
        isToAllZones: true, // 是否要发往所有分区，如果不是则表示仅发往选定的某几个分区
        selectedZoneIds: [], // 分区id集合
        isSendByPlayerIds: true, // 按玩家id还是按渠道
        isToAllChannels: true, // 是否要发往所有渠道，如果不是则表示仅发往选定的某几个渠道
        selectedChannelIds: [], // 渠道id集合
        playerIds: "", // 玩家id集合
        attachments: [], // 附件集合
      },
      availableAttachments: [],
      attachmentSeq: 0,
      requestId: util.uuid(), // 请求id，用于防止重发
    };
  },

  props: {
    value: Object,
  },

  components: {
    ZoneSelector,
    ChannelSelector,
    MailAttachment,
  },

  async created() {
    if (this.value.channelId != 0) {
      this.form.selectedChannelId = this.value.channelId;
    }

    await this.loadAvailableAttachments();
  },

  methods: {
    async onZoneSelectorChange(newValue, oldValue) {
      this.form.selectedZoneIds = newValue;
    },

    async onChannelSelectorChange(newValue, oldValue) {
      this.form.selectedChannelIds = newValue;
    },

    onIsToAllZonesSwitchChange() {
      if (this.form.isToAllZones) {
        // 清除单独选择的分区集合
        this.$refs.zoneSelector.clear();
      }
    },

    onIsToAllChannelsSwitchChange() {
      if (this.form.isToAllChannels) {
        // 清除单独选择的渠道集合
        this.$refs.channelSelector.clear();
      }
    },

    onIsSendByPlayerIdsRadioGroupChange() {
      if (this.form.isSendByPlayerIds) {
        this.form.isToAllChannels = true;
      } else {
        // 清除填入的玩家id集合
        this.form.playerIds = "";
      }
    },

    //全服邮件提示
    openIsToAll(args) {
      if (this.form.isToAll) {
        this.$confirm("渠道内所有玩家作为邮件发送目标，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).catch(() => {
          this.form.isToAll = false;
        });
      }
    },

    /**
     * 查询可用附件集合
     */
    async loadAvailableAttachments() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/game/getGameObjectsConfig`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let gameObjectCategories = JSON.parse(resData.data.data);

      for (let category of gameObjectCategories) {
        this.availableAttachments.push({
          label: category.name,
          value: category.name,
          children: (() => {
            let result = [];
            for (let e of category.entries) {
              result.push({
                label: e.name,
                value: e.id,
                children: (() => {
                  if (!e.qualities) {
                    return null;
                  }

                  let result = [];
                  for (let q of e.qualities) {
                    result.push({
                      label: q.qualityName,
                      value: q.quality,
                    });
                  }
                  return result;
                })(),
              });
            }
            return result;
          })(),
        });
      }
    },

    /**
     * 增加一个附件
     */
    addNewAttachment() {
      this.form.attachments.push({
        seq: ++this.attachmentSeq,
        data: {
          valuesOfNodes: [],
          number: "1",
        },
      });
    },

    /**
     * 删除一个附件
     */
    removeAttachment(seq) {
      for (let i = 0; i < this.form.attachments.length; i++) {
        if (this.form.attachments[i].seq == seq) {
          this.form.attachments.splice(i, 1);
          break;
        }
      }
    },

    /**
     * 提交表单
     */
    async submit() {
      // 分区集合
      let zoneIds = [];
      if (!this.form.isToAllZones) {
        if (this.form.selectedZoneIds.length == 0) {
          this.$message({
            message: "请选择分区",
            type: "error",
          });
          return;
        }

        zoneIds = this.form.selectedZoneIds;
      }

      // 渠道集合
      let channelIds = [];
      if (!this.form.isToAllChannels) {
        if (this.form.selectedChannelIds.length == 0) {
          this.$message({
            message: "请选择渠道",
            type: "error",
          });
          return;
        }

        channelIds = this.form.selectedChannelIds;
      }

      // 玩家id集合
      let playerIds = [];
      if (this.form.isSendByPlayerIds) {
        let parseResult = this.parsePlayerIds();
        if (parseResult.err) {
          this.$message({
            message: parseResult.err,
            type: "error",
          });
          return;
        }

        playerIds = parseResult.list;

        if (playerIds.length == 0) {
          this.$message({
            message: "请正确填入玩家ID集合",
            type: "error",
          });
          return;
        }
      }

      // 附件集合
      let attachments = [];
      for (let e of this.form.attachments) {
        if (e.data.valuesOfNodes.length == 0) {
          this.$message({
            message: "请正确选择附件",
            type: "error",
          });
          return;
        }

        // 在数组e.data.valuesOfNodes当中，第0个元素是分类标识，所以需要跳过，第1个元素是id，第2个元素是品质（可能会没有第2个元素）
        let attachment = {
          confId: e.data.valuesOfNodes[1],
          number: e.data.number,
        };
        if (e.data.valuesOfNodes.length == 3) {
          attachment.quality = e.data.valuesOfNodes[2];
        }

        attachments.push(attachment);
      }

      console.log("---- uuid:", util.uuid())

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/mail/send`,
          {
            templateId: `${this.value.mailTemplate.id}`,
            attachments: attachments,
            isAllZones: this.form.isToAllZones,
            zoneIds: zoneIds,
            isAllChannels: this.form.isToAllChannels,
            channelIds: channelIds,
            isAllPlayers: !this.form.isSendByPlayerIds,
            pids: playerIds,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
              requestId: this.requestId,
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      this.$message({
        message: "发送成功",
        type: "success",
      });

      // 关闭当前对话框
      this.visible = false;
    },

    /**
     * 解析玩家id集合
     *
     * @returns {list: [], err: "xxxx"}
     */
    parsePlayerIds() {
      let list = [];

      let playerIdsStr = this.form.playerIds.trim();
      if (playerIdsStr.length > 0) {
        let arr = playerIdsStr.split(/\s+/);
        for (let e of arr) {
          let id = Number(e);
          if (isNaN(id) || id != parseInt(id)) {
            return {
              list: [],
              err: "玩家ID格式错误",
            };
          }

          if (id <= 0) {
            return {
              list: [],
              err: "玩家ID必须是正整数",
            };
          }

          list.push(id);
        }
      }

      return {
        list: list,
      };
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>